import { z } from "zod";
export const ANNOUNCEMENTS = [
    {
        id: "analytics-2026-10",
        title: "Tests is now Analytics",
        publishedAt: "2026-10-05",
        expiresAt: "2026-11-05",
    },
    {
        id: "peak-week-2026-10",
        title: "Amines on HPLC, your tanks at a glance, and bottle prep",
        publishedAt: "2026-10-23",
        expiresAt: "2026-11-23",
    },
];
export const announcementIdSchema = z.enum(ANNOUNCEMENTS.map((a) => a.id));
const utcDay = (date) => Date.parse(`${date}T00:00:00Z`);
export function isAnnouncementLive(announcement, now) {
    const t = now.getTime();
    return t >= utcDay(announcement.publishedAt) && t < utcDay(announcement.expiresAt);
}
/**
 * The newest live announcement this operator has not been shown, if any.
 * `operatorSince` (when the operator first signed in) excludes announcements
 * published after it: a newcomer has nothing to be told has changed.
 */
export function pickAnnouncement(seen, now, list, operatorSince = null) {
    const candidates = list
        .filter((a) => isAnnouncementLive(a, now) &&
        !seen.has(a.id) &&
        (operatorSince === null ||
            operatorSince.getTime() < utcDay(a.publishedAt)))
        .sort((a, b) => utcDay(b.publishedAt) - utcDay(a.publishedAt));
    return candidates[0] ?? null;
}
/**
 * Showing an announcement retires it and every announcement published no later
 * than it: an operator who was away for two releases sees only the latest one,
 * never a queue of popups on consecutive loads.
 */
export function retiredBy(shown, list) {
    return list.filter((a) => utcDay(a.publishedAt) <= utcDay(shown.publishedAt));
}
/**
 * Published within the last `days` days, counting the release day itself:
 * how long the home page keeps pointing at it.
 */
export function isRecentAnnouncement(announcement, now, days = 7) {
    const since = now.getTime() - utcDay(announcement.publishedAt);
    return since >= 0 && since < days * 24 * 60 * 60 * 1000;
}
/** The most recently published announcement, live or not: what "What's new" opens. */
export function latestAnnouncement(list) {
    return [...list].sort((x, y) => utcDay(y.publishedAt) - utcDay(x.publishedAt))[0] ?? null;
}
export function findAnnouncement(id) {
    return ANNOUNCEMENTS.find((a) => a.id === id);
}
//# sourceMappingURL=announcements.js.map